const enviroments = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  APP_ID: process.env.REACT_APP_APP_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  AUTHORIY: process.env.REACT_APP_AUTHORIY,
  CC_MOBILE: process.env.REACT_APP_CC_MOBILE,
  API_URL_INDENTITY: process.env.REACT_APP_API_URL_IDENTITY,
  API_URL_LOCAIS: process.env.REACT_APP_API_URL_LOCAIS,
  API_URL_POLEPOSITION: process.env.REACT_APP_API_URL_POLEPOSITION,
  API_URL_NOTIFICATION: process.env.REACT_APP_URL_API_HUB_NOTIFICACOES,
  API_URL_AGENDAMENTO: process.env.REACT_APP_API_URL_AGENDAMENTO,
  API_URL_USERS: process.env.REACT_APP_API_URL_IDENTITY,
  API_URL_LEAD: process.env.REACT_APP_API_URL_LEAD,
  API_URL_DATA_COMMON: process.env.REACT_APP_API_URL_DATA_COMMON,
  URL_ADMIN: process.env.REACT_APP_URL_ADMIN,
  CONEXAO_URL: process.env.REACT_APP_CONEXAO_URL,
  API_URL_AGENDAMENTO_RESERVA:
    process.env.REACT_APP_API_URL_AGENDAMENTO_RESERVA,
  API_URL_SOCKET: process.env.REACT_APP_URL_API_HUB_NOTIFICACOES,
  TOKEN_HEADER: process.env.REACT_APP_HEADER,
  AMBIENTE: process.env.REACT_APP_TYPE_OF_ENVIRONMENT,
};
export default enviroments;
